<template>
  <popup-container>
    <template slot="header">
      {{ $l['languageSelect'] }}
    </template>

    <div
      class="popup-option"
      v-for="(option, index) in options"
      :key="index"
      @click="select(option)">
      {{ $l[option.name] }}
    </div>
  </popup-container>
</template>

<script>
import PopupContainer from '@/components/Popup/Container'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [ MixinLocale ],
  components: {
    PopupContainer
  },

  data () {
    return {
      options: [
        { name: 'japanese', value: 'ja' },
        { name: 'english', value: 'en' }
      ]
    }
  },

  methods: {
    select: function (lang) {
      this.$store.dispatch('locale/changeLang', lang.value)
      this.$store.dispatch('locale/save')
      this.$store.dispatch('popup/hide', null)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
